// src/components/CardLink.jsx
//
// The secondary navigation link in a card's header or a list row — "View
// all", "View full breakdown", "View full report" — pointing at a fuller
// view of what the card summarises.
//
// Renders via .card-link (index.css): --amber-text rather than
// --brand-accent, because the gold text these used to be is 3.28:1 on white —
// under the 4.5:1 WCAG AA floor for 12px text. A chevronRight icon replaces
// the ASCII "→" every call site used to type by hand.
//
// Pass `to` for a route (renders a react-router Link) or `onClick` for an
// in-page action (renders a button) — never both.
import React from 'react';
import { Link } from 'react-router-dom';
import Icon from './Icon';

export default function CardLink({ to, onClick, children, ariaLabel, className = '' }) {
  const content = (
    <>
      <span>{children}</span>
      <Icon name="chevronRight" size={14} />
    </>
  );
  const cls = `card-link ${className}`.trim();

  if (to) {
    return (
      <Link to={to} className={cls} aria-label={ariaLabel}>
        {content}
      </Link>
    );
  }
  return (
    <button type="button" className={cls} onClick={onClick} aria-label={ariaLabel}>
      {content}
    </button>
  );
}
